import { on } from "@ngrx/store";

import { WorkOrdersActions } from "../job-workorders/job-workorders.actions";

import { AddDiscountsModalActions } from "./add-discounts-modal.actions";
import { AddDiscountsModalState, jobAddDiscountsModalInitialState } from "./add-discounts-modal.state";

export const jobAddDiscountsModalReducers = [
  on(AddDiscountsModalActions.discountSelected, (state: AddDiscountsModalState, { discountId, amount }) => {
    return {
      ...state,
      addDiscountsModal: {
        ...state.addDiscountsModal,
        discountId,
        amount,
      }
    };
  }),
  on(AddDiscountsModalActions.amountInputChanged, (state: AddDiscountsModalState, { amount }) => {
    return {
      ...state,
      addDiscountsModal: {
        ...state.addDiscountsModal,
        amount,
      }
    };
  }),
  on(AddDiscountsModalActions.eventSelectionChanged, (state: AddDiscountsModalState, { eventIds }) => {
    return {
      ...state,
      addDiscountsModal: {
        ...state.addDiscountsModal,
        eventIds,
      }
    };
  }),
  on(
    WorkOrdersActions.addDiscountsButtonClicked,
    (state: AddDiscountsModalState, { eventId, discountId, amount }): AddDiscountsModalState => {
      return {
        ...state,
        addDiscountsModal: {
          ...jobAddDiscountsModalInitialState.addDiscountsModal,
          discountId,
          visible: true,
          eventIds: [ eventId ],
          amount,
        },
      };
    },
  ),
  on(
    AddDiscountsModalActions.cancelButtonClicked,
    AddDiscountsModalActions.closeButtonClicked,
    (state: AddDiscountsModalState) => {
      return {
        ...state,
        addDiscountsModal: {
          ...jobAddDiscountsModalInitialState.addDiscountsModal,
        },
      };
    },
  ),
  on(AddDiscountsModalActions.mutateDiscountDialogOpened, (state: AddDiscountsModalState): AddDiscountsModalState => {
    return {
      ...state,
      addDiscountsModal: {
        ...jobAddDiscountsModalInitialState.addDiscountsModal,
      },
    };
  }),
  on(WorkOrdersActions.discountAdded, (state: AddDiscountsModalState): AddDiscountsModalState => {
    return {
      ...state,
      addDiscountsModal: {
        ...jobAddDiscountsModalInitialState.addDiscountsModal,
      },
    };
  }),
];
